import { useChannels } from '@entities/channel'
import { InternetRecourceType } from '@entities/channel/model/types'
import type { UserPermissions } from '@entities/user'
import { useCurrentUser } from '@entities/user/model/hooks/use-current-user'
import { useMemo } from 'react'
import { RoutePermission } from '../types'

// Конфигурация маршрутов с разрешениями
export const ROUTE_PERMISSIONS: Record<string, RoutePermission[]> = {
    '/statistics': [RoutePermission.STATISTICS],
    '/posts': [RoutePermission.POSTING],
    '/posts/scheduled': [RoutePermission.POSTING],
    '/posts/draft': [RoutePermission.POSTING],
    '/posts/published': [RoutePermission.POSTING],
    '/advertising': [RoutePermission.ADVERTISING],
    '/advertising/partners': [RoutePermission.ADVERTISING_PARTNERS],
    '/advertising/partners/add': [RoutePermission.ADVERTISING_PARTNERS_ADD],
    '/advertising/partners/edit/:id': [RoutePermission.ADVERTISING_PARTNERS_EDIT],
    '/advertising/buy': [RoutePermission.ADVERTISING_BUY],
    '/advertising/sell': [RoutePermission.ADVERTISING_SELL]
}

// Публичные маршруты, доступные всем
export const PUBLIC_ROUTES = ['/login']

const standardUserPermissions: UserPermissions = {
    main: true,
    channels: true,
    posting: true,
    advertising: true,
    advertisingBuy: true,
    advertisingSell: true,
    advertisingPartners: true,
    statistics: true,
    settings: true,
    profile: true
}

const anonymousUserPermissions: UserPermissions = {
    main: true,
    channels: true,
    posting: true,
    advertising: true,
    advertisingBuy: true,
    advertisingSell: true,
    advertisingPartners: true,
    statistics: true,
    settings: true,
    profile: true
}

export const usePermissions = () => {
    const { currentChannel, currentChannelPermissions } = useChannels()
    const { user } = useCurrentUser()

    const permissions = useMemo(
        () => ({
            ...(user?.isAnonymous ? anonymousUserPermissions : standardUserPermissions),
            ...currentChannelPermissions,
            ...(currentChannel?.type === InternetRecourceType.site ? { posting: false, advertisingSell: false } : {})
        }),
        [currentChannel?.type, currentChannelPermissions, user?.isAnonymous]
    )

    const hasPermission = (permission: RoutePermission): boolean => {
        return permissions ? permissions[permission] : true
    }

    const hasPermissions = (permissions: RoutePermission[] = []): boolean => {
        return permissions.every(hasPermission)
    }

    return { hasPermissions, hasPermission }
}
